import React, { useCallback, useEffect, useRef, useState } from "react";
import { AiFillEye, AiOutlineDelete } from "react-icons/ai";
import { TfiClose, TfiFilter, TfiPencil } from "react-icons/tfi";
import Loading from "../../common/Loading";
import FilterSide from "../../common/FilterSide";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getsubTopicData } from "../../redux/services/subTopicSlice";
import NoDataFound from "../../common/NoDataFound";
import { getQuestionData, questionDelete, uploadQApdf } from "../../redux/services/questionSlice";
import { useUser } from "../../redux/services/authSlice";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import { BiSearch } from "react-icons/bi";
import QuestionUpload from "./QuestionUpload";

const SubjectDetails = () => {
  const questionTypes = [
    { id: "normal", label: "Normal" },
    { id: "statement", label: "Statement" },
    { id: "pair", label: "Pair" },
    { id: "normal-csat", label: "Normal-Csat" },
    { id: "statement-csat", label: "Statement-Csat" },
  ];
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const classesId = localStorage.getItem("classesId");
  const subjectId = queryParams.get("subjectId");
  const { user } = useUser();
  const userId = user?._id;
  const storedDetails = localStorage.getItem("subjectDetails");
  const details = storedDetails ? JSON.parse(storedDetails) : {};
  const name = details.name || "";
  const dispatch = useDispatch();
  const subTopicIds = useSelector((state) => state.subTopic.subTopicData?.[0]?.subTopicIds || []);
  const questionData = useSelector((state) => state?.question?.questionData);
  const questionLoading = useSelector((state) => state?.question?.questionLoading);
  const [toggle, setToggle] = useState(false);
  const [selectedValue, setSelectedValue] = useState();
  const [selectedSubtopic, setSelectedSubtopic] = useState();
  const [viewModal, setViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");

  const closeModal = () => {
    setViewModal(false);
    setViewData(null);
  };
  const [page, setPage] = useState(() => {
    return localStorage.getItem("currentPage") ? parseInt(localStorage.getItem("currentPage"), 10) : 0;
  });
  useEffect(() => {
    const savedPage = localStorage.getItem("currentPage");
    if (savedPage) {
      setPage(parseInt(savedPage, 10));
    }
  }, []);
  const limit = 10;
  const [filters, setFilters] = useState({
    normal: false,
    statement: false,
    pair: false,
    "normal-csat": false,
    "statement-csat": false,
  });
  const [queType, setQueType] = useState();
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [subTopicId, setSubTopicId] = useState();
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const handleDelete = (questionId) => {
    setItemToDelete(questionId);
    setConfirm(true);
  };
  const handleSelectionChange = (selectedValue) => {
    if (selectedValue === "") {
      setSubTopicId(null);
    } else {
      setSubTopicId(selectedValue);
    }
    setSelectedSubtopic(selectedValue);
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };
  useEffect(() => {
    if (searchData) {
      setPage(0);
    }
  }, [searchData]);

  const applyFilters = () => {
    const activeFilters = Object.entries(filters)
      .filter(([_, value]) => value)
      .map(([key]) => key);
    setQueType(activeFilters);
    setFiltersApplied(true);
    setToggle(false);
  };
  const clearFilter = () => {
    setQueType([]);
    setFilters({});
    setFiltersApplied(false);
    setToggle(false);
    setSelectedValue(null);
  };
  const fetchSubTopic = useCallback(async () => {
    try {
      await dispatch(getsubTopicData(subjectId));
    } catch (error) {
      console.error("Failed to fetch sub-topic data", error);
    }
  }, [subjectId, dispatch]);

  useEffect(() => {
    fetchSubTopic();
  }, [fetchSubTopic]);
  const getSubjectWiseQuestion = useCallback(async () => {
    try {
      await dispatch(
        getQuestionData({
          page: page + 1,
          limit: limit,
          classesFilter: userId || classesId,
          subjectId,
          subTopicId,
          queType,
          selectedValue,
          search: searchData,
        }),
      );
    } catch (error) {}
  }, [dispatch, page, limit, userId, subjectId, subTopicId, classesId, queType, selectedValue, searchData]);

  useEffect(() => {
    if (subjectId || userId || subTopicId || filtersApplied) {
      getSubjectWiseQuestion();
      setFiltersApplied(false);
    }
  }, [getSubjectWiseQuestion, filtersApplied, subjectId, userId, subTopicId, queType, selectedValue]);
  const deleteQuestion = async () => {
    try {
      const response = await dispatch(questionDelete(itemToDelete));
      toast(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getSubjectWiseQuestion();
    } catch (error) {}
  };

  const selectOptions = [
    { value: "", label: "All" },
    ...(Array.isArray(subTopicIds)
      ? subTopicIds.map((option) => ({
          value: option._id,
          label: option.name,
        }))
      : []),
  ];
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "0.375rem",
      borderColor: "#D1D5DB",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#124699",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#124699" : "white",
      color: state.isSelected ? "white" : "#4B5563",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: state.isSelected ? "#124699" : "#e8effa",
        color: state.isSelected ? "white" : "#4B5563",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#4B5563",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#4B5563",
      "&:hover": {
        color: "#124699",
      },
    }),
  };
  // useEffect(() => {
  //   return () => {
  //     localStorage.removeItem("currentPage");
  //   };
  // }, []);
  return (
    <div className="p-4">
      <section className="bg-white p-4 overflow-y-auto min-h-full rounded-lg border border-slate-300 font-sans">
        <div className="flex justify-between lg:flex-row flex-col gap-3">
          <div className="relative max-w-md w-full flex items-center gap-3">
            <p className="text-lg font-medium text-gray-900">Search:</p>
            <input
              type="text"
              className="max-w-md w-full px-4 py-2 border rounded-lg focus:outline-none"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setSearchData(searchTerm);
                }
              }}
            />
            <button type="button" className="absolute top-0 right-0 px-4 h-full bg-[#124699] text-white rounded-r-lg" onClick={() => setSearchData(searchTerm)}>
              <BiSearch />
            </button>
          </div>
          <div className="flex gap-3 justify-end sm:flex-row flex-col">
            <button onClick={() => setToggle(!toggle)} className="inline-flex items-center space-x-2 rounded-lg px-2 py-2 text-md uppercase text-[#124699] border-2 border-[#124699] hover:bg-opacity-90">
              <TfiFilter className="font-bold text-[#124699] w-4 h-4" />
              <p className="font-semibold">Filter</p>
            </button>
            <QuestionUpload subjectId={subjectId} getSubjectWiseQuestion={getSubjectWiseQuestion} />
            <button
              onClick={() =>
                navigate(`/addQuestion?subjectId=${subjectId}`, {
                  state: { name: name },
                })
              }
              className="flex items-center gap-3 rounded-lg px-2 py-2 text-md uppercase text-white bg-[#124699] hover:bg-opacity-90 border-2 border-[#124699]"
            >
              <p className="font-semibold">Create New Question</p>
            </button>
          </div>
        </div>

        <div className="mt-6 flex sm:flex-row flex-col justify-between items-center w-full gap-3">
          <div className="w-full max-w-sm">
            <p className="md:text-2xl text-xl font-semibold text-gray-900 uppercase">{name}</p>
            <div className="w-full max-w-xl flex justify-between">
              <Select id={`Subtopic-select`} value={selectOptions.find((opt) => opt.value === selectedSubtopic)} onChange={(selectedOption) => handleSelectionChange(selectedOption ? selectedOption.value : "")} options={selectOptions} placeholder="Select Subtopic" styles={customStyles} isClearable className="mt-1 block w-full" classNamePrefix="custom-select" />
            </div>
          </div>
          {questionData?.totalData && <p className="text-xl font-semibold text-gray-900">Total Questions : {questionData?.totalData}</p>}
        </div>

        {questionLoading ? (
          <Loading />
        ) : (
          <div className="w-full space-y-6 md:gap-16 font-sans mt-6">
            {questionData?.question_data?.length > 0 ? (
              <ul className="space-y-4">
                {questionData?.question_data?.map((value, index) => (
                  <li key={index} className="">
                    <div className="md:flex items-center justify-between text-lg font-medium text-gray-900 mt-5">
                      <div className="flex items-center gap-x-4">
                        <p className="text-lg font-medium text-blue-gray-900 capitalize">{page * limit + index + 1}</p>
                        <p className="text-lg font-medium text-blue-gray-900 capitalize">{value?.englishQuestion?.question}</p>
                      </div>
                      <div className="flex items-center justify-end space-x-4 pr-2 md:mt-0 mt-2">
                        <span className={`${value.type === "concept" ? "bg-green-100 text-green-600" : value.type === "aptitude" ? "bg-yellow-100 text-yellow-600" : value.type === "random" ? "bg-red-100 text-red-600" : "bg-gray-100 text-gray-900"} px-4 text-sm leading-8 font-medium rounded-full capitalize`}>{value.type}</span>
                        <button className={`inline-flex items-center space-x-2 rounded-lg px-3.5 py-1 text-md uppercase bg-yellow-100 border hover:bg-opacity-90`}>{value.englishQuestion.answer}</button>
                        <button
                          onClick={() => {
                            setViewData(value);
                            setViewModal(true);
                          }}
                          className="inline-flex items-center space-x-2 rounded-lg px-2 py-2 text-md uppercase bg-blue-100 border hover:bg-opacity-90"
                        >
                          <AiFillEye className="font-bold w-5 h-5" />
                        </button>

                        <button onClick={() => handleDelete(value._id)} className="inline-flex items-center space-x-2 rounded-lg px-2 py-2 text-md uppercase bg-red-100 border hover:bg-opacity-90">
                          <AiOutlineDelete className="font-bold w-5 h-5" />
                        </button>

                        <button
                          onClick={() => {
                            navigate(`/editQuestion?questionId=${value._id}`);
                          }}
                          className="inline-flex items-center space-x-2 rounded-lg px-2 py-2 text-md uppercase bg-green-100 border hover:bg-opacity-90"
                        >
                          <TfiPencil className="font-bold w-5 h-5" />
                        </button>
                      </div>
                    </div>
                    <div className="rounded-md border mt-3 border-gray-300 md:px-6 md:py-4 px-4 py-2 text-md text-justify font-normal text-gray-500 shadow-inner ">
                      <p className="line-clamp-3">
                        {" "}
                        {value?.questionType === "statement" || value?.questionType === "statement-csat" ? value?.englishQuestion?.statementQuestion?.[0]?.combined : null}
                        {value?.questionType === "normal" || value?.questionType === "normal-csat" ? value?.englishQuestion?.solution : null}
                        {value?.questionType === "pair" ? value?.englishQuestion?.pairQuestion?.[0]?.combined : null}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <NoDataFound />
            )}
          </div>
        )}
        <div className="mt-4">
          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            pageCount={questionData?.state?.page_limit}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            forcePage={page}
            onPageChange={(data) => {
              setPage(data.selected);
              localStorage.setItem("currentPage", data.selected);
            }}
            containerClassName={"pagination flex justify-center items-center"}
            pageClassName={"page-item py-2 rounded"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item py-2 rounded"}
            nextClassName={"page-item py-2 rounded"}
            activeClassName={"active text-white"}
            disabledClassName={"disabled bg-gray-100 text-gray-500 cursor-not-allowed"}
          />
        </div>
        <div className={`${confirm === true ? "block" : "hidden"}`}>
          <ConfirmationPage confirm={confirm} onDelete={deleteQuestion} closeModal={() => setConfirm(false)} />
        </div>
        <div className={`${toggle === true ? "block" : "hidden"}`}>
          <FilterSide filterData={filters} onChange={handleCheckboxChange} apply={applyFilters} onClose={() => setToggle(!toggle)} questionTypes={questionTypes} selectedValue={selectedValue} setSelectedValue={setSelectedValue} clearFilter={clearFilter} />
        </div>
      </section>
      {viewModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 mx-3 max-w-2xl max-h-[90vh] overflow-y-auto custom-scrollbar">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Question Details</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-800">
                <TfiClose />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <p className="font-medium">Question:</p>
                <p className="text-gray-700">{viewData?.englishQuestion?.question}</p>
              </div>
              <div>
                <p className="font-medium">Solution:</p>
                <p className="text-gray-700">{viewData?.englishQuestion?.solution}</p>
              </div>
            </div>

            <div className="mt-6 flex justify-end">
              <button onClick={closeModal} className="px-4 py-2 bg-[#124699] text-white rounded-lg hover:bg-[#124699]">
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubjectDetails;
